import React from "react";
import { Button } from "@mui/material";

const CustomButton = ({
  text,
  className = "",
  endIcon,
  startIcon,
  ...props
}) => {
  return (
    <Button
      variant="contained"
      endIcon={endIcon}
      startIcon={startIcon}
      className={className}
      {...props}
    >
      {text}
    </Button>
  );
};

export default CustomButton;
